import { Avatar, Grid, PaperProps, Typography } from '@mui/material';
import React from 'react';
import { getUserInitials } from 'utilities/utilityFunctions';
import { colors } from 'styles/colors';
import { ReactComponent as CloseGreenIcon } from 'assets/closeLightGreenIcon.svg';

export interface IEmployeePillProps extends PaperProps {
  index: number;
  employeeFullName: string;
  isShowAvatar?: boolean;
  onClose?: () => void;
}

const bgColors = ['#C8ECED', '#D2DFD7', '#D2DFD7', '#E9C7CD'];

const getBackGroundColor = (index: number) =>
  bgColors[index]
    ? bgColors[index]
    : bgColors[Math.floor(Math.random() * bgColors.length)];

const EmployeeChip: React.FC<IEmployeePillProps> = ({
  index,
  employeeFullName,
  isShowAvatar,
  onClose,
}) => {
  const backColor = getBackGroundColor(index);
  return (
    <Grid item key={index}>
      <Grid
        id={`chip-${index}`}
        data-testid={`chip-${index}`}
        sx={{
          display: 'flex',
          lineHeight: 2,
          padding: ({ typography }) =>
            `${typography.pxToRem(6)} ${typography.pxToRem(
              12
            )} ${typography.pxToRem(6)} ${typography.pxToRem(
              (isShowAvatar && 8) || 12
            )}`,
          borderRadius: 2,
          border: `1px solid ${colors.tertiary.green}`,
          width: 'fit-content',
          backgroundColor: colors.background.componentBackground,
        }}
        aria-label={employeeFullName}
        tabIndex={0}
      >
        <Grid
          mb={0}
          sx={{
            ':focus': { width: 'fit-content' },
            display: 'inline-flex',
            alignItems: 'center',
            alignSelf: 'center',
          }}
        >
          {isShowAvatar && (
            <Avatar
              sx={{
                fontFamily: 'Segoe UI',
                fontWeight: 600,
                fontSize: ({ typography }) => `${typography.pxToRem(12)}`,
                lineHeight: 1,
                height: '1.375rem',
                width: '1.5rem',
                mr: ({ typography }) => `${typography.pxToRem(8)}`,
                color: colors.type.copy,
                backgroundColor: backColor,
              }}
            >
              {getUserInitials(employeeFullName)}
            </Avatar>
          )}
          <Typography
            id={`EmployeeChip-${index}-label1`}
            data-testid={`EmployeeChip-${index}-label1`}
            className='kfic2-bodyTextSmall'
            title={employeeFullName}
            sx={{
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '18rem',
            }}
          >
            {employeeFullName}
          </Typography>
          {onClose && (
            <CloseGreenIcon
              style={{
                marginLeft: '8px',
                cursor: 'pointer',
              }}
              onClick={onClose}
              onKeyUp={(e) => e.key === 'Enter' && onClose()}
              data-testid={`${index}-close-icon`}
              aria-label='Remove Icon'
              tabIndex={0}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
export default EmployeeChip;
